import _ from 'lodash';
import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox } from '../../../components/Box';
import { Button } from '../../../components/Buttons';
import { Content } from '../../../components/Content';
import { ArrowDown, ArrowUp, Plus, EditSquare, Times } from '../../../components/Icon';
import { List, Row, Cell } from '../../../components/List';
import { Loader } from '../../../components/Loader';
import { selectWorks } from '../../Api/selectors';
import {
  addColumn,
  columnDelete,
  columnSetAction,
  columnSortDown,
  columnSortUp,
  editBoardName,
  editColumnName,
  fetchKanbanBoard,
} from '../actions';
import { REQUEST_KANBAN_BOARD, REQUEST_KANBAN_BOARD_COLUMN_OPERATION } from '../constants';
import { selectKanbanBoard } from '../selectors';
import { Modal, ModalControls } from '../../../components/Modal';
import { fetchActions } from '../../Actions/actions';
import { Dropdown } from '../../../components/Dropdown';
import { selectActions } from '../../Actions/selectors';
import { FormField } from '../../../components/FormFields';
import { Input } from '../../../components/Input';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';

const Container = styled.div`
  .controls {
    width: 10px;
  }
`;

const Action = styled.div`
  display: inline-block;
`;

const STATE = {
  setAction: null,
  selectedSetAction: null,
  addColumn: null,
  addColumnName: '',
  editColumnLabel: null,
  editColumnLabelValue: '',
  editBoardName: false,
  editBoardNameValue: '',
};

/* eslint-disable react/prefer-stateless-function */
class KanbanBoardEditComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.fetch();
  }

  reset() {
    this.setState({ ...STATE });
  }

  get board() {
    return this.props.board;
  }

  render() {
    if (!this.board || !this.props.actions?.length) return <Loader small />;

    return (
      <Container>
        {this.renderSetAction()}
        {this.renderAddColumn()}
        {this.renderEditColumnLabel()}
        {this.renderEditBoardName()}
        <Content>
          <div className="editable-text" onClick={this.setStateFn({ editBoardName: true })}>
            <h3>{this.board.label}</h3>
          </div>

          <hr />
          <Button small onClick={this.setStateFn({ addColumn: true })}>
            <Plus /> column
          </Button>
          <List>
            {_(this.board.columns)
              .sortBy([column => column.KanbanBoardHasKanBoardColumn.sort_order])
              .map(this.renderColumn.bind(this))
              .value()}
          </List>
        </Content>
      </Container>
    );
  }

  renderColumn(column, index) {
    return (
      <Row key={column.id}>
        <Cell className="controls">
          <Button disabled={this.props.work} small onClick={() => this.props.sortUp(column.id)}>
            <ArrowUp />
          </Button>

          <Button disabled={this.props.work} small onClick={() => this.props.sortDown(column.id)}>
            <ArrowDown />
          </Button>

          <Button disabled={this.props.work} small onClick={() => this.props.delete(column.id)}>
            <Times />
          </Button>
        </Cell>
        <Cell>{column.KanbanBoardHasKanBoardColumn.sort_order}</Cell>

        <Cell>
          <div className="editable-text" onClick={this.setStateFn({ editColumnLabel: column.id })}>
            {column.label}
          </div>
        </Cell>
        <Cell>
          <HBox left vCenter>
            <Button small inline onClick={this.setStateFn({ setAction: column.id })}>
              <EditSquare />
            </Button>
            {this.renderAction(column.actions?.[0])}
          </HBox>
        </Cell>
      </Row>
    );
  }

  renderAction(action) {
    if (!action) return null;
    return (
      <Action>
        <span style={{ opacity: '0.3', marginRight: '12px' }}>{action.id}</span>
        {action.functionName}
      </Action>
    );
  }

  renderSetAction() {
    if (!this.state.setAction) return null;

    const column = this.props.board.columns.find(c => c.id === this.state.setAction);
    const options = this.props.actions.map(action => ({ label: action.functionName, value: action.id }));
    const selected = options.find(o => o.value === (this.state.selectedSetActionId || column.actions[0]?.id));

    return (
      <ModalComponent onClose={this.reset.bind(this)} title={this.lbl('kanban.edit.column.action.set.modal.title')}>
        <Dropdown options={options} value={selected} onChange={pair => this.setState({ selectedSetActionId: pair.value })} />
        <ModalControls>
          <Button
            isPrimary
            onClick={() => {
              this.props.setColumnAction(this.state.setAction, selected?.value, this.reset.bind(this));
            }}
          >
            {this.lbl('confirm')}
          </Button>
          <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </ModalComponent>
    );
  }

  renderAddColumn() {
    if (!this.state.addColumn) return null;
    return (
      <Modal onClose={this.reset.bind(this)} title={this.lbl('kanban.edit.column.modal.add.column.title')}>
        <FormField label={this.lbl('name')}>
          <Input name="addColumnName" value={this.state.addColumnName} onChange={this.onInputChange.bind(this)} />
        </FormField>
        <ModalControls>
          <Button
            isPrimary
            onClick={() => {
              this.props.addColumn(this.state.addColumnName, this.reset.bind(this));
            }}
          >
            {this.lbl('confirm')}
          </Button>
          <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }

  renderEditColumnLabel() {
    if (!this.state.editColumnLabel) return;
    return (
      <Modal onClose={this.reset.bind(this)} title={this.lbl('kanban.edit.column.modal.edit.label.title')}>
        <FormField label={this.lbl('name')}>
          <Input
            name="editColumnLabelValue"
            value={this.state.editColumnLabelValue}
            onChange={this.onInputChange.bind(this)}
          />
        </FormField>
        <ModalControls>
          <Button
            isPrimary
            onClick={() => {
              this.props.renameColumn(this.state.editColumnLabel, this.state.editColumnLabelValue, this.reset.bind(this));
            }}
          >
            {this.lbl('confirm')}
          </Button>
          <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }

  renderEditBoardName() {
    if (!this.state.editBoardName) return;
    return (
      <Modal onClose={this.reset.bind(this)} title={this.lbl('kanban.edit.modal.edit.name.title')}>
        <FormField label={this.lbl('name')}>
          <Input name="editBoardNameValue" value={this.state.editBoardNameValue} onChange={this.onInputChange.bind(this)} />
        </FormField>
        <ModalControls>
          <Button
            isPrimary
            onClick={() => {
              this.props.renameBoard(this.state.editBoardNameValue, this.reset.bind(this));
            }}
          >
            {this.lbl('confirm')}
          </Button>
          <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }
}

KanbanBoardEditComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    board: selectKanbanBoard(ownProps.board_id),
    work: selectWorks([REQUEST_KANBAN_BOARD, REQUEST_KANBAN_BOARD_COLUMN_OPERATION]),
    actions: selectActions(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch() {
      dispatch(fetchKanbanBoard(ownProps.board_id));
      dispatch(fetchActions());
    },
    setColumnAction(columnId, actionId, cb) {
      dispatch(columnSetAction(ownProps.board_id, columnId, actionId, cb));
    },
    sortUp(columnId) {
      dispatch(columnSortUp(ownProps.board_id, columnId));
    },
    sortDown(columnId) {
      dispatch(columnSortDown(ownProps.board_id, columnId));
    },
    delete(columnId) {
      dispatch(columnDelete(ownProps.board_id, columnId));
    },
    addColumn(name, callback) {
      dispatch(addColumn(ownProps.board_id, name, callback));
    },
    renameColumn(columnId, name, callback) {
      dispatch(editColumnName(ownProps.board_id, columnId, name, callback));
    },
    renameBoard(name, callback) {
      dispatch(editBoardName(ownProps.board_id, name, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const KanbanBoardEdit = compose(withConnect, withRouter)(KanbanBoardEditComp);
